import React from 'react';
import { SkeletonBar } from '../../ui/Skeleton/SkeletonBar';

export const CoordinatesBadgeSkeleton: React.FC = () => (
    <div data-testid="followup-coordinates-skeleton" aria-hidden="true" className="flex items-center gap-s self-start px-m py-m rounded-lg bg-surface-secondary">
        <SkeletonBar className="size-4 shrink-0" shape="circle" />
        <SkeletonBar className="h-3 w-64 max-w-full" />
    </div>
);
